export default "./dist/stdassets/images/icons/search.png";